import { ReactComponent as SvgIcon } from '@img/icons/chevron-down.svg';
import { useReducedMotion } from 'framer-motion';
import React from 'react';
import S from './BackToTop.styles';
const BackToTop = () => {
    const shouldReduceMotion = useReducedMotion();
    return (React.createElement(S.Container, null,
        React.createElement(S.Button, { type: "button", onClick: (event) => {
                event.preventDefault();
                window.scrollTo({
                    behavior: shouldReduceMotion ? 'auto' : 'smooth',
                    left: 0,
                    top: 0,
                });
            } },
            React.createElement(S.Text, null, "Back to the Top"),
            React.createElement(S.Icon, { as: SvgIcon, "aria-hidden": true }))));
};
export default BackToTop;
